/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  ProsecutionRole,
  ProsecutionRoleCreate,
  ProsecutionRoleUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ProsecutionRoleFromJSON,
    ProsecutionRoleToJSON,
    ProsecutionRoleCreateFromJSON,
    ProsecutionRoleCreateToJSON,
    ProsecutionRoleUpdateFromJSON,
    ProsecutionRoleUpdateToJSON,
} from '../models/index';

export interface CreateProsecutionRoleApiV1ProsecutionRolesPostRequest {
    prosecutionRoleCreate: ProsecutionRoleCreate;
}

export interface CreateProsecutionRoleApiV1ProsecutionRolesPost0Request {
    prosecutionRoleCreate: ProsecutionRoleCreate;
}

export interface DeleteProsecutionRoleApiV1ProsecutionRolesIdDeleteRequest {
    id: number;
}

export interface ReadProsecutionRoleByIdApiV1ProsecutionRolesIdGetRequest {
    id: number;
}

export interface ReadProsecutionRolesApiV1ProsecutionRolesGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadProsecutionRolesApiV1ProsecutionRolesGet0Request {
    skip?: number;
    limit?: number;
}

export interface UpdateProsecutionRoleApiV1ProsecutionRolesIdPutRequest {
    id: number;
    prosecutionRoleUpdate: ProsecutionRoleUpdate;
}

/**
 * 
 */
export class ProsecutionRolesApi extends runtime.BaseAPI {

    /**
     * Create new prosecution role.
     * Create Prosecution Role
     */
    async createProsecutionRoleApiV1ProsecutionRolesPostRaw(requestParameters: CreateProsecutionRoleApiV1ProsecutionRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProsecutionRole>> {
        if (requestParameters['prosecutionRoleCreate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionRoleCreate',
                'Required parameter "prosecutionRoleCreate" was null or undefined when calling createProsecutionRoleApiV1ProsecutionRolesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionRoleCreateToJSON(requestParameters['prosecutionRoleCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionRoleFromJSON(jsonValue));
    }

    /**
     * Create new prosecution role.
     * Create Prosecution Role
     */
    async createProsecutionRoleApiV1ProsecutionRolesPost(requestParameters: CreateProsecutionRoleApiV1ProsecutionRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProsecutionRole> {
        const response = await this.createProsecutionRoleApiV1ProsecutionRolesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new prosecution role.
     * Create Prosecution Role
     */
    async createProsecutionRoleApiV1ProsecutionRolesPost_1Raw(requestParameters: CreateProsecutionRoleApiV1ProsecutionRolesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProsecutionRole>> {
        if (requestParameters['prosecutionRoleCreate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionRoleCreate',
                'Required parameter "prosecutionRoleCreate" was null or undefined when calling createProsecutionRoleApiV1ProsecutionRolesPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionRoleCreateToJSON(requestParameters['prosecutionRoleCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionRoleFromJSON(jsonValue));
    }

    /**
     * Create new prosecution role.
     * Create Prosecution Role
     */
    async createProsecutionRoleApiV1ProsecutionRolesPost_1(requestParameters: CreateProsecutionRoleApiV1ProsecutionRolesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProsecutionRole> {
        const response = await this.createProsecutionRoleApiV1ProsecutionRolesPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a prosecution role.
     * Delete Prosecution Role
     */
    async deleteProsecutionRoleApiV1ProsecutionRolesIdDeleteRaw(requestParameters: DeleteProsecutionRoleApiV1ProsecutionRolesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProsecutionRole>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProsecutionRoleApiV1ProsecutionRolesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionRoleFromJSON(jsonValue));
    }

    /**
     * Delete a prosecution role.
     * Delete Prosecution Role
     */
    async deleteProsecutionRoleApiV1ProsecutionRolesIdDelete(requestParameters: DeleteProsecutionRoleApiV1ProsecutionRolesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProsecutionRole> {
        const response = await this.deleteProsecutionRoleApiV1ProsecutionRolesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific prosecution role by id.
     * Read Prosecution Role By Id
     */
    async readProsecutionRoleByIdApiV1ProsecutionRolesIdGetRaw(requestParameters: ReadProsecutionRoleByIdApiV1ProsecutionRolesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProsecutionRole>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readProsecutionRoleByIdApiV1ProsecutionRolesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionRoleFromJSON(jsonValue));
    }

    /**
     * Get a specific prosecution role by id.
     * Read Prosecution Role By Id
     */
    async readProsecutionRoleByIdApiV1ProsecutionRolesIdGet(requestParameters: ReadProsecutionRoleByIdApiV1ProsecutionRolesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProsecutionRole> {
        const response = await this.readProsecutionRoleByIdApiV1ProsecutionRolesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve prosecution roles.
     * Read Prosecution Roles
     */
    async readProsecutionRolesApiV1ProsecutionRolesGetRaw(requestParameters: ReadProsecutionRolesApiV1ProsecutionRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProsecutionRole>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProsecutionRoleFromJSON));
    }

    /**
     * Retrieve prosecution roles.
     * Read Prosecution Roles
     */
    async readProsecutionRolesApiV1ProsecutionRolesGet(requestParameters: ReadProsecutionRolesApiV1ProsecutionRolesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProsecutionRole>> {
        const response = await this.readProsecutionRolesApiV1ProsecutionRolesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve prosecution roles.
     * Read Prosecution Roles
     */
    async readProsecutionRolesApiV1ProsecutionRolesGet_2Raw(requestParameters: ReadProsecutionRolesApiV1ProsecutionRolesGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProsecutionRole>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProsecutionRoleFromJSON));
    }

    /**
     * Retrieve prosecution roles.
     * Read Prosecution Roles
     */
    async readProsecutionRolesApiV1ProsecutionRolesGet_2(requestParameters: ReadProsecutionRolesApiV1ProsecutionRolesGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProsecutionRole>> {
        const response = await this.readProsecutionRolesApiV1ProsecutionRolesGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a prosecution role.
     * Update Prosecution Role
     */
    async updateProsecutionRoleApiV1ProsecutionRolesIdPutRaw(requestParameters: UpdateProsecutionRoleApiV1ProsecutionRolesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProsecutionRole>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProsecutionRoleApiV1ProsecutionRolesIdPut().'
            );
        }

        if (requestParameters['prosecutionRoleUpdate'] == null) {
            throw new runtime.RequiredError(
                'prosecutionRoleUpdate',
                'Required parameter "prosecutionRoleUpdate" was null or undefined when calling updateProsecutionRoleApiV1ProsecutionRolesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/prosecution-roles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProsecutionRoleUpdateToJSON(requestParameters['prosecutionRoleUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProsecutionRoleFromJSON(jsonValue));
    }

    /**
     * Update a prosecution role.
     * Update Prosecution Role
     */
    async updateProsecutionRoleApiV1ProsecutionRolesIdPut(requestParameters: UpdateProsecutionRoleApiV1ProsecutionRolesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProsecutionRole> {
        const response = await this.updateProsecutionRoleApiV1ProsecutionRolesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
